/**
 * Copyright Highway9 Networks Inc.
 */
import { OBJ_STATUS } from '~/constants/constants';
import {
  AccountCircleRounded,
  ExitToAppRounded,
  PeopleAltOutlined,
  ShoppingCartRounded,
  GroupWorkRounded,
  PauseCircleOutlineRounded,
  EqualizerRounded,
  TuneRounded,
  LocationOnRounded,
  SettingsInputAntennaRounded,
  DevicesRounded,
  DeviceHub,
  Edit,
  DeleteRounded,
  CheckCircleOutlineRounded,
  TimerOutlined,
  ErrorOutlineRounded,
  AccessTimeOutlined,
  CancelOutlined,
  GetApp,
  InfoTwoTone,
  CodeOutlined,
  Settings,
  CancelRounded,
  CheckCircle,
  Apartment,
  MenuBookRounded,
  CloudDownloadRounded,
  CloudUploadRounded,
  SimCard,
  FiberManualRecord,
  MoveDown,
  ArrowRight,
  ArrowDropDown,
  ReportProblemTwoTone,
  RemoveCircleOutline,
  Delete,
  ContentPasteGo,
  CellTower,
  Memory,
  Tag,
  TurnedIn,
  TurnedInNot,
  AvTimer,
  Info,
  AddCircle,
  Visibility,
  VisibilityOff,
  HandshakeTwoTone,
  DataObject,
  Handshake,
  Tune,
  LockOutlined,
  AccountTree,
  DeveloperMode,
  Security,
  SettingsSuggest,
  AutoDelete,
  TimerRounded,
  SupportAgent,
  ArrowCircleUpTwoTone,
  RuleFolder,
  HeadsetMic
} from "@mui/icons-material";
import GroupsIcon from "@mui/icons-material/Groups";
import EngineeringIcon from "@mui/icons-material/Engineering";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MenuIcon from "@mui/icons-material/Menu";
import DescriptionIcon from '@mui/icons-material/Description';
import { CircularProgress, SvgIconProps ,LinearProgress , colors} from "@h9/ui-lib";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import EmailIcon from "@mui/icons-material/Email";
import BlockIcon from "@mui/icons-material/Block";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import Publish from "@mui/icons-material/Publish";
import CopyIcon from "@mui/icons-material/FileCopyOutlined";
import GroupIcon from "@mui/icons-material/Group";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";
import PageviewIcon from "@mui/icons-material/Pageview";
import TimelineIcon from "@mui/icons-material/Timeline";
import ViewAgendaOutlinedIcon from "@mui/icons-material/ViewAgendaOutlined";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Crop75Icon from "@mui/icons-material/Crop75";
import { StyledBadge1 } from "./StyledBadge";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import { asset } from "../assets";
import ExtensionIcon from "@mui/icons-material/Extension";
import SettingsIcon from "@mui/icons-material/Settings";
import InventoryIcon from "@mui/icons-material/Inventory";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import StyleIcon from "@mui/icons-material/Style";
import CategoryIcon from "@mui/icons-material/Category";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import SaveIcon from "@mui/icons-material/Save";
import SubtitlesIcon from "@mui/icons-material/Subtitles";
import SubtitlesOffIcon from "@mui/icons-material/SubtitlesOff";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import ArticleIcon from '@mui/icons-material/Article';
import KeyIcon from '@mui/icons-material/Key';
import PermDeviceInformationIcon from '@mui/icons-material/PermDeviceInformation';
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ReportIcon from '@mui/icons-material/ReceiptLong';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ChromeReaderModeIcon from "@mui/icons-material/ChromeReaderMode";
import { JSX } from 'react';

/** SKU / model definitions — used for SKUs tab, forms, and legacy `assignSKU` alias. */
const skuModelIcon = <StyleIcon titleAccess="SKU" />;

/** Vendor logos in table/forms (paths under `public/`, same as orch-ui). */
const vendorLogoImgStyle = { width: 18, height: 18, verticalAlign: "middle" as const, objectFit: "contain" as const };

const { grey, red, amber, lightBlue, teal, blue, orange } = colors;
const style = {
  marginBottom: 2,
};

export const Images = {
  H9NLogo: "images/highway9networks.png",
  loginImg: "images/highway9_background.png",
  GCP: "images/GCP.png",
  AWS: "images/AWS.png",
  AZURE: "images/AZURE.png",
  onPrem: "images/OnPrem.svg.jpg",
  radio: "images/celltower.png",
  radioLocation: "images/celltower_red.png",
  GAR: "images/GAR.png",
  GOA: "images/GOA.png",
  GO: "images/GO.png",
  AG: "images/AG.png",
  AO: "images/AO.png",
  GOAR: "images/GOAR.png",
  ARO: "images/ARO.png",
  GOR: "images/GOR.png",
  AR: "images/AR.png",
  RO: "images/RO.png",
  GR: "images/GR.png",
  wentWrong: "images/wentWrong.png",
  highway9Logo: asset.highway9Logo,
  IndoorRadio: asset.radioIndoor,
  signInGoogle: "/images/signInGoogle.webp",
  signInMicrosoft: "/images/signInMicrosoft.webp",
  signInCustom: "/images/signInOpenIdCustom.png",
  monitorLogo: asset.monitorLogo,
  airspan: "images/airspan.png",
  baicells: "images/baicells.png",
  multitech: "images/multitech.png",
  fortinet: "images/fortinet.png",
  digi: "images/digi.png",
  askey: "images/askey.png",
  horizon: "images/horizon.png",
  bec: "images/BEC.png",
  cradlepoint: "images/cradlepoint.png",
  sierraWireless: "images/sierraWireless.png",
};

export const Icons = {
  customerSupportIcon: <HeadsetMic />,
  deviceInfo : <PermDeviceInformationIcon />,
  APN_DNN: <AccountTree style={style} />,
  policies: <ViewInArIcon titleAccess="Policies" />,
  simulators: <DeveloperMode titleAccess="Simulators" />,
  VMZ: <Security titleAccess="" />,
  systemSettingsIcon: <SettingsSuggest titleAccess="Settings" />,
  certificate: <WorkspacePremiumIcon />,
  ipsecCertificates: <VerifiedUserOutlinedIcon />,
  key : <KeyIcon />,
  tenant: <Apartment />,
  partner: <Handshake />,
  msp: <GroupsIcon />,
  systemEngineer: <EngineeringIcon />,
  orderManagement: <ShoppingCartRounded />,
  serviceInstance: <GroupWorkRounded style={{}} />,
  pausedServiceInstance: <PauseCircleOutlineRounded />,
  userIcon: ({size = 20}) => <AccountCircleRounded style={{ color: "616161", ...style , fontSize : size,marginRight: 4}} />,
  serviceExtension : (props : SvgIconProps) => <ExtensionIcon {...props} />,
  report: <ReportIcon titleAccess="Report" />,
  logoutIcon: <ExitToAppRounded style={{ width: 20 }} />,
  chevronLeftIcon: <ChevronLeftIcon />,
  chevronRightIcon: <ChevronRightIcon />,
  userManagement: <PeopleAltOutlined />,
  cloudDashboard: <EqualizerRounded />,
  settings: <TuneRounded />,
  inboxIcon: <InboxIcon />,
  menuIcon: <MenuIcon />,
  installationSteps: <MoveDown />,
  edge: <DeviceHub />,
  EdgeSmall: (props: SvgIconProps) => <DeviceHub sx={{ width: 16 }} {...props}/>,
  location: <LocationOnRounded />,
  radios: <SettingsInputAntennaRounded />,
  subscribers: <DevicesRounded sx={{ width: 32 }} />,
  subscribersSmall: <DevicesRounded sx={{ width: 16 }} />,
  edit: <Edit style={{ width: 20 }} />,
  metrics: <TimelineIcon />,
  deleteRounded: <DeleteRounded style={{ paddingTop: 3 }} />,
  view: <PageviewIcon />,
  login: <LoginIcon />,
  logout: <LogoutIcon fontSize="small" />,
  add: <AddCircle />,
  inProgress: <CircularProgress size={25} thickness={5} />,
  registered: <CheckCircleOutlineRounded style={{ color: "#026950" }} />,
  accessTimeIcon: <AccessTimeOutlined fontSize="small" style={{ color: grey[500] }} />,
  accessTimeIconForTable: <AccessTimeOutlined fontSize="small" style={{ color: grey[500] }} />,
  /** PTP clock product type — highway9 green (not grey; grey reads as in-progress). */
  ptpClock: <AvTimer fontSize="small" style={{ color: "#03695F", width: 20, height: 20 }} />,
  acknowledged: <TimerOutlined style={{ color: grey[500] }} />,
  timerRounded: <TimerRounded style={{ color: grey[500] }} />,
  failed: <ErrorOutlineRounded style={{ color: red[500] }} />,
  users: <GroupIcon />,
  user: <PersonIcon />,
  logs: <MenuBookRounded />,
  SAML: <LockIcon />,
  email: <EmailIcon />,
  role: <SupervisorAccountIcon />,
  tenantAdminRole: <SupervisedUserCircleIcon />,
  operatorRole: <ManageAccountsIcon />,
  copy: <CopyIcon />,
  upload: <Publish />,
  download: <GetApp />,
  info: <InfoTwoTone color="primary" />,
  infoMutedSmall: <InfoTwoTone sx={{ color: "#B5B5B5", height: "16px" }} />,
  infoWarning: <ReportProblemTwoTone style={{ color: "#FFCD38" }} />,
  password: <VpnKeyIcon />,
  code: <CodeOutlined />,
  vertDots: <MoreVertIcon />,
  configuration: <Settings />,
  cancel: <CancelRounded style={{ color: red[500] }} />,
  cancelOutlinedIcon: <CancelOutlined style={{ color: orange[500] }} />,
  active: <CheckCircle style={{ color: "#026950" }} />,
  inactive: <CheckCircle style={{ color: grey[500] }} />,
  operator_role: <ManageAccountsIcon />,
  tenant_admin_role: <SupervisedUserCircleIcon />,
  other_roles: <AssignmentIndIcon />,
  export: <CloudDownloadRounded />,
  enabledIcon: <CheckCircleOutlineIcon style={{ ...style, color: "#07695F" }} />,
  import: <CloudUploadRounded />,
  IMSIBlock: <ViewAgendaOutlinedIcon />,
  simcard: <SimCard style={{ ...style, color: "#026950" }} />,
  esimcard: (
    <StyledBadge1 badgeContent={"e"} color="secondary">
      <SimCard style={{ ...style, color: "#026950" }} />
    </StyledBadge1>
  ),
  simvendor: <ContactPageIcon style={{ ...style, color: "#026950" }} />,
  filedownload: <FileDownloadIcon />,
  imsirow: <Crop75Icon />,
  visibility: <Visibility />,
  visibilityOff: <VisibilityOff />,
  resync: <CloudSyncIcon />,
  greenCircle: <FiberManualRecord style={{ color: "#03695F" }} />,
  greyCircle: <FiberManualRecord style={{ color: grey[500] }} />,
  amberCircle: <FiberManualRecord style={{ color: amber[500] }} />,
  redCircle: <FiberManualRecord style={{ color: red[500] }} />,
  radio: <CellTower />,
  radioSmall: <CellTower sx={{ width: 16 }} />,
  // radioSmall: <img src={Images.radio} alt="Radio" height="16px" />,
  unknownIcon: <ExtensionIcon color="disabled" />,
  operation: <SettingsIcon />,
  expand: <ArrowRight style={{ color: grey[500] }} />,
  collapse: <ArrowDropDown style={{ color: grey[500] }} />,
  /** Tree component: collapsed node (chevron right). */
  treeExpand: <ChevronRightIcon />,
  /** Tree component: expanded node (chevron down). */
  treeCollapse: <ExpandMoreIcon />,
  inventory: <InventoryIcon />,
  /** Parts catalog (distinct from generic inventory). */
  partsCatalog: <Inventory2Icon titleAccess="Parts" />,
  /** SKU / product model definitions. */
  skuModel: skuModelIcon,
  /** Composite SKU (mixes multiple product types). */
  compositeSku: <CategoryIcon titleAccess="Composite SKU" />,
  revoke: <RemoveCircleOutline />,
  hardwareInventory: <Memory />,
  addAbove: <AddCircle style={{ color: lightBlue[500] }} />,
  addBelow: <AddCircle style={{ color: teal[500] }} />,
  delete: <Delete />,
  assignHardware: <ContentPasteGo />,
  assignSKU: skuModelIcon,
  cradlepoint: <img alt="Cradlepoint" src={Images.cradlepoint} style={vendorLogoImgStyle} />,
  sierraWireless: <img alt="Sierra Wireless" src={Images.sierraWireless} style={vendorLogoImgStyle} />,
  baicells: <img alt="Baicells" src={Images.baicells} style={vendorLogoImgStyle} />,
  airspan: <img alt="Airspan" src={Images.airspan} style={vendorLogoImgStyle} />,
  bec: <img alt="BEC" src={Images.bec} style={vendorLogoImgStyle} />,
  multitech: <img alt="MultiTech" src={Images.multitech} style={vendorLogoImgStyle} />,
  fortinet: <img alt="Fortinet" src={Images.fortinet} style={vendorLogoImgStyle} />,
  digi: <img alt="Digi" src={Images.digi} style={vendorLogoImgStyle} />,
  askey: <img alt="Askey" src={Images.askey} style={vendorLogoImgStyle} />,
  horizon: <img alt="Horizon" src={Images.horizon} style={vendorLogoImgStyle} />,
  /** When vendor name does not match a known logo. */
  vendorUnknown: <Handshake sx={{ width: 18, height: 18, opacity: 0.55 }} titleAccess="Vendor" />,
  /** Default / Highway9 vendor — handshake in brand green. */
  vendorDefault: <Handshake sx={{ width: 18, height: 18, color: "#03695F" }} titleAccess="Default" />,
  /** RMA (return merchandise authorization) actions. */
  ruleFolder: <RuleFolder titleAccess="RMA" />,
  cellTowerGreen: <CellTower style={{ color: "#03695F" }} />,
  cellTowerRed: <CellTower style={{ color: red[500] }} />,
  cellTowerOrange: <CellTower style={{ color: orange[500] }} />,
  cellTowerBlue: <CellTower style={{ color: blue[500] }} />,
  cellTowerGrey: <CellTower style={{ color: grey[500] }} />,
  application: <ViewInArIcon />,
  tag: <TurnedIn style={{ color: "#03695F" }} />,
  /** Product class — inventory table column and Product Class tab. */
  productClass: <TurnedInNot style={{ color: "#03695F" }} titleAccess="Product Class" />,
  simManagement: <SimCard />,
  ECIManagement: <Tag />,
  LoaderIcon: <SaveIcon />,
  inService: <SubtitlesIcon style={{ color: "#03695F" }} />,
  underMaintenance: <SubtitlesOffIcon style={{ color: red[500] }} />,
  green: <FiberManualRecord style={{ color: "#07695F" }} />,
  red: <ErrorIcon style={{ color: red[500] }} />,
  ErrorGrey:<ErrorIcon style={{ color: grey[500] }} />,
  grey: <FiberManualRecord style={{ color: grey[500] }} />,
  infoIcon: <Info />,
  markForDeletion: <AutoDelete />,
  closeIcon: <CloseIcon />,
  orange: <FiberManualRecord style={{ color: orange[500] }} />,
  handshake: <HandshakeTwoTone />,
  paid: <PaidOutlinedIcon titleAccess="Paid" />,
  partnerRadioAgent: <ConnectWithoutContactIcon />,
  summary: <DataObject titleAccess="Summary" />,
  Administration: <Tune titleAccess="Administration" />,
  documentIcon: <ArticleIcon />,
  documentationIcon: <DescriptionIcon />,
  supportIcon: <SupportAgent />,
  /** Ziva prompt library — slide-out panel tab and header. */
  promptLibrary: (props: SvgIconProps) => <ChromeReaderModeIcon {...props} />,
  upgradeWarning:<LockOutlined/>,
  upgradeAvailable:<ArrowCircleUpTwoTone style={{ color: orange[500] }} />,
  locked:<LockOutlined color='error'/>,
  fileUpload: <FileUploadOutlinedIcon />,
  DeleteIcon: (props: SvgIconProps) => <DeleteIcon {...props} />,
  deleting: (
      <span style={{ display: "inline-block" }}>
        <DeleteIcon titleAccess="Deleting" />
        <LinearProgress color="error" style={{ width: 12, marginLeft: 4, marginTop: -7 }} />
      </span>
    ),
    disabledIcon: <BlockIcon style={{ ...style, color: grey[500] }} titleAccess="Disabled" />,
  indoorRadio: ({ width = 18, height = 18 } : any) => (
    <img
      title="Radio: Indoor"
      alt="Radio Indoor"
      src={Images.IndoorRadio}
      style={{ width, height}}
    />),
    signInGoogle: <img src={Images.signInGoogle} alt="Google" height="28px" />,
    signInMicrosoft: <img src={Images.signInMicrosoft} alt="Microsoft" height="28px" />,
    signInCustom: <img src={Images.signInCustom} alt="Custom" height="28px" />,
    monitorLogo: <img src={Images.monitorLogo} alt="Monitor" height="16px" />,
};

/**
 * Resolves a hardware vendor string to a logo (Baicells, Airspan, …) or a generic vendor icon.
 */
export function getVendorIcon(vendor: string | undefined): JSX.Element | null {
  if (!vendor?.trim()) {
    return null;
  }
  const n = vendor.trim().toLowerCase();
  if (n.includes("baicell")) {
    return Icons.baicells;
  }
  if (n.includes("airspan")) {
    return Icons.airspan;
  }
  if (n.includes("multitech")) {
    return Icons.multitech;
  }
  if (n.includes("fortinet")) {
    return Icons.fortinet;
  }
  if (n.includes("digi")) {
    return Icons.digi;
  }
  if (n.includes("askey")) {
    return Icons.askey;
  }
  if (n.includes("horizon")) {
    return Icons.horizon;
  }
  if (n.includes("bec")) {
    return Icons.bec;
  }
  if (n.includes("cradlepoint")) {
    return Icons.cradlepoint;
  }
  if (n.includes("sierra")) {
    return Icons.sierraWireless;
  }
  if (n.includes("highway") || n === "h9") {
    return <img alt="" src={Images.highway9Logo} style={vendorLogoImgStyle} />;
  }
  if (n === "default") {
    return Icons.vendorDefault;
  }
  return Icons.vendorUnknown;
}


export const getStatusIcon = (status:string) => {
  switch (status) {
    case OBJ_STATUS.DEPLOYED:
      return Icons.enabledIcon;

    case OBJ_STATUS.DEPLOYING:
    case OBJ_STATUS.IN_PROGRESS:
    case OBJ_STATUS.REVOKING:
    case OBJ_STATUS.MARKED_FOR_REVOKE:
      return  Icons.inProgress;

    case OBJ_STATUS.FAILED:
      return  Icons.red;

    case OBJ_STATUS.MARKED_FOR_DELETE:
      return  Icons.markForDeletion;

    case OBJ_STATUS.DELETING:
      return  Icons.deleting;

    default:
      return  Icons.disabledIcon;
  }
  };
export const withLoading = (Icon: JSX.Element) => {
  return (
    <div style={{ position: "relative", display: "inline-block", marginTop: "5px" }}>
      {Icon}
      <LinearProgress style={{ position: "absolute", bottom: "-5px", left: "0", width: "18px" }} />
    </div>
  );
};

export const withWaiting = (Icon: JSX.Element, color = "#fc8d26") => {
  return (
    <div style={{ position: "relative", display: "inline-block", marginTop: "5px" }}>
      {Icon}

      <TimerRounded
        style={{ position: "absolute", top: "-5px", right: "-5px", fontSize: "small", color: color }}
        // titleAccess={ titleAccess || "Time" }
      />
    </div>
  );
};

export const withError = (Icon: JSX.Element, color = red[500]) => {
  return (
    <div style={{ position: "relative", display: "inline-block", marginTop: "5px" }}>
      {Icon}
      <ErrorIcon
        style={{ position: "absolute", top: "-5px", right: "-5px", fontSize: "small", color: color }}
        // titleAccess="Error"
      />
    </div>
  );
};

export const withDelete = (Icon: JSX.Element, color = red[500] as string) => {
  return (
    <div style={{ position: "relative", display: "inline-block", marginTop: "5px" }}>
      {Icon}
      <AutoDelete
        style={{ position: "absolute", top: "-5px", right: "-5px", fontSize: "small", color: color }}
        // titleAccess="AutoDelete"
      />
    </div>
  );
};

/**
 *
 * @param {JSX.Element} Icon
 * @param {string } state  DEPLOYED | DEPLOYING | NOT_DEPLOYED | FAILED | MARKED_FOR_REBOOT | MARKED_FOR_DELETE | DELETING | MARKED_FOR_UPDATE | WAITING | UPDATING
 * @returns {JSX.Element}
 * @example
 *
 * const Icon = withState(<DeviceIcontitleAccess=""/>, DEPLOYED)
 */
export const withState = (Icon: JSX.Element, state: OBJ_STATUS) => {
  switch (state) {
    case OBJ_STATUS.DEPLOYING:
    case OBJ_STATUS.UPGRADING:
    case OBJ_STATUS.UPDATING:
    case OBJ_STATUS.DELETING:
      return withLoading(Icon);

    // DISABLING withError Status Icons FOR NOW
    // As there is a separate icon ahead for displaying the Bad / Good Health status for the VMC as of now
    // case OBJ_STATUS.FAILED:
    // case OBJ_STATUS.DELETE_FAILED:
    // case OBJ_STATUS.UPGRADE_FAILED:
    // case OBJ_STATUS.UPDATE_FAILED:
    //   return withError(Icon);

    case OBJ_STATUS.MARKED_FOR_DELETE:
      return withDelete(Icon, "gray");

    case OBJ_STATUS.NOT_DEPLOYED:
    case OBJ_STATUS.MARKED_FOR_UPGRADE:
    case OBJ_STATUS.MARKED_FOR_RETRY:
    case OBJ_STATUS.MARKED_FOR_UPDATE:
      return withWaiting(Icon, "gray");

    case OBJ_STATUS.DEPLOYED:
    default:
      return Icon;
  }
};
